import { ContentSource } from '@/modules/ai/models/ContentSource';
import { Route } from '@/modules/core/app/constants/api.constants';
import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';
import { BaseListService } from '@/modules/core/table/services/BaseListService';

export class ContentSourceListService extends BaseListService {
  getRoute(): string {
    return Route.AI_CONTENTSOURCE;
  }

  getModel(): BaseModel {
    return ContentSource;
  }

  addParams(params: Params = {}): Params {
    params.with = [
      'lastEditedUser',
      'county',
      'country',
      'contentSourceJurisdictions.jurisdiction',
      'contentSourceDocument',
      'contentSourceRoles'
    ];

    return super.addParams(params);
  }
}

export default new ContentSourceListService();
